import styled, { css } from "styled-components";

import { colors, radii } from "shared/ui/tokens";

type IconButtonSize = "large" | "medium" | "small";
type IconButtonVariant = "plain" | "outlined";

const SIZES: Record<IconButtonSize, { box: string; icon: string }> = {
    large: { box: "44px", icon: "20px" },
    medium: { box: "32px", icon: "20px" },
    small: { box: "28px", icon: "18px" },
};

const outlined = css`
    border: 1px solid ${colors.fieldBorder};
    background: ${colors.surface};
`;

export const Button = styled.button<{
    $size: IconButtonSize;
    $variant: IconButtonVariant;
    $tone: "default" | "danger";
}>`
    position: relative;
    width: ${({ $size }) => SIZES[$size].box};
    height: ${({ $size }) => SIZES[$size].box};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: none;
    padding: 0;
    border: none;
    border-radius: ${radii.order};
    background: transparent;
    color: ${({ $tone }) => ($tone === "danger" ? colors.danger : colors.textSecondary)};
    cursor: pointer;
    ${({ $variant }) => ($variant === "outlined" ? outlined : "")}

    svg {
        font-size: ${({ $size }) => SIZES[$size].icon};
    }

    &:hover:not(:disabled) {
        background: ${({ $tone }) =>
            $tone === "danger" ? colors.dangerHover : "rgba(0,0,0,0.04)"};
    }

    &:disabled {
        opacity: 0.4;
        cursor: default;
    }

    &:focus-visible {
        outline: 2px solid ${colors.primary};
        outline-offset: 1px;
    }
`;
